import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0H7.6V7.6H0V0Z",
			fill: "#F25022"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4 0H16V7.6H8.4V0Z",
			fill: "#7FBA00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 8.4H7.6V16H0V8.4Z",
			fill: "#00A4EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4 8.4H16V16H8.4V8.4Z",
			fill: "#FFB900"
		})
	]
});
export default SvgMicrosoft;
